/** Стандартные размеры страниц для API-запросов. */
export const PAGE_SIZE = {
  MICRO: 5,
  SMALL: 10,
  DEFAULT: 20,
  LARGE: 50,
  MAX: 1000,
} as const;
